/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepRedirectUser
 */
export interface StepRedirectUser extends SignupStep {
    /**
     * An path where to redirect the user
     * @type {string}
     * @memberof StepRedirectUser
     */
    redirectPath?: string;
}

/**
 * Check if a given object implements the StepRedirectUser interface.
 */
export function instanceOfStepRedirectUser(value: object): value is StepRedirectUser {
    return true;
}

export function StepRedirectUserFromJSON(json: any): StepRedirectUser {
    return StepRedirectUserFromJSONTyped(json, false);
}

export function StepRedirectUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepRedirectUser {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
        'redirectPath': json['redirectPath'] == null ? undefined : json['redirectPath'],
    };
}

export function StepRedirectUserToJSON(value?: StepRedirectUser | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
        'redirectPath': value['redirectPath'],
    };
}

